import React, { Fragment } from 'react'
import * as ReactDOM from 'react-dom'
import AppAction from 'components/AppAction/AppAction'

let globalMessgeInstance: any[] = []

export default {
	confirm(message1: string, isdangerous: boolean = false): Promise<any> {
		return new Promise(resolve => {
			let div = document.createElement('div')

			document.body.appendChild(div)

			let comfirm = () => {
				this.close()
				resolve(true)
			}
			let onClose = () => {
				this.close()
				resolve(false)
			}

			let content = (
				<Fragment>
					<div className="app-warning-bg"></div>
					<div className="app-warning">
						<div className="app-warning-border">
							<div>{message1}</div>
						</div>
						{isdangerous === false ? (
							<AppAction title="确认" action={comfirm} type="primary" />
						) : (
							<AppAction title="删除" action={comfirm} type="dangerous" />
						)}

						<AppAction title="取消" action={onClose} type="default" />
						{/* <AppAction title="确认" action={comfirm} type="primary" /> */}
						{/* <AppAction type="default"/> */}
					</div>
				</Fragment>
			)
			ReactDOM.render(content, div)
			globalMessgeInstance.push(div)
		})
	},
	alark(message1: string): Promise<any> {
		return new Promise(resolve => {
			let div = document.createElement('div')

			document.body.appendChild(div)

			let onClose = () => {
				this.close()
			}
			/*设置app-dialog-body的高度*/
			let content = (
				<Fragment>
					<div className="app-warning-bg"></div>
					<div className="app-warning">
						<div className="app-warning-border">
							<div>{message1}</div>
						</div>
						<AppAction title="确定" action={onClose} type="primary" />
						{/* <AppAction title="确认" action={comfirm} type="primary" /> */}
						{/* <AppAction type="default"/> */}
					</div>
				</Fragment>
			)

			ReactDOM.render(content, div)
			globalMessgeInstance.push(div)
		})
	},

	close() {
		requestAnimationFrame(() => {
			let div = globalMessgeInstance.pop()
			const unmountResult = ReactDOM.unmountComponentAtNode(div)
			if (unmountResult && div.parentNode) {
				div.parentNode.removeChild(div)
			}
		})
	},
}



// WEBPACK FOOTER //
// ./src/components/AppMessage/index.tsx